<template>
<b-container>
  
   <b-row class="question">
      <b-col>
        <p class="h5 mb-4" v-html="$t('labels.essentialServicePrompt')"></p>
        <BaseRadioInput v-model="essentialItemAccess" 
                            :v="$v.essentialItemAccess"
                            :label="$t('labels.essentialServices')"
                            :options=yesNoUnknownOptions
                            slug="essentialServices"/>
      </b-col>
    </b-row>
  <b-row v-if="essentialItemAccess === 'N'">
    <b-col>
      <BaseMultiCheckboxInput v-model="essentialItemsSelections"
                    :v="$v.essentialItemsSelections"
                    :label="$t('labels.essentialServiceDetails')"
                    :options=essentialItemOptions
                    slug="essentialItems"
                    multiple
        />
    </b-col>
  </b-row>
  <b-row v-if="essentialItemAccess === 'N'">
    <b-col>
      <BaseTextInput v-model="essentialItemOther"
                     :v="$v.essentialItemOther"
                     :label="$t('labels.essentialItemOther')"
                     slug="essentialItemOther"/>
    </b-col>
  </b-row>

  <b-row class="question">
    <b-col>
      <p class="mt-4 center" v-html="$t('labels.essentialMoreInfo')"></p>
    </b-col>
  </b-row>
</b-container>

</template>

<script>
import { required, email, minLength, maxLength, numeric, requiredUnless, requiredIf } from 'vuelidate/lib/validators'
import { commonOptions } from '@/mixins/commonOptions.js'
import moment from 'moment'
import _ from "lodash"
import i18n from '@/i18n'
export default {
  components: {},
  mixins: [
       commonOptions
    ],
  props: {
    symptoms: [Object]
  },
  data: () => ({
    essentialItemAccess: null,
    essentialItems: null,
    essentialItemsSelections: null,
    essentialItemOther: null,
  }),

  computed: {
    _() {
      return this._
    },
  },
  
  validations() {
    return {
      essentialItemAccess: { required: false },
      essentialItems: {required: false},
      essentialItemsSelections: {required: requiredIf(function() { return this.essentialItemAccess === 'N' }) },
      essentialItemOther: {required: false},
      form: [ 'essentialItemAccess', 'essentialItems', 'essentialItemsSelections', 'essentialItemOther' ]
    }
  },
  
  watch: {
     essentialItemsSelections: function () {
      this.essentialItems = this.essentialItemsSelections.join()
    }
  },

  methods: {
      validate() {
        this.$v.form.$touch();
        var isValid = !this.$v.form.$invalid
        this.$emit('on-validate', this.$data, isValid)
        return isValid
      }
  }
}
</script>

<style>

</style>
